import { PlanMyCruiseContainerProps } from '@msc-b2c/interfaces/types';
import styles from './planMyCruiseContainer.module.scss';

export function PlanMyCruiseContainer({ children }: Readonly<PlanMyCruiseContainerProps>) {
  return <div className={styles.planMyCruiseContainer}> {children} </div>;
}

export default PlanMyCruiseContainer;
